import { useTranslation } from "react-i18next"
import { BellRinging, TrashSimple } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { NewsFragment$data } from "@/modules/admin/news/services/__generated__/NewsFragment.graphql"

interface PlannedNewsProps {
  dataNews: NewsFragment$data
  onShowNews: (id: string) => void
  onDeleteNews: (id: string) => void
}

const PlannedNews = ({ dataNews, onShowNews, onDeleteNews }: PlannedNewsProps) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-row">
      <div className="basis-1/4 border-r border-l pr-4 pl-4">
        <Button
          variant="circle"
          className="h-10 w-10"
          onClick={(e) => {
            e.stopPropagation()
            onDeleteNews(dataNews.id)
          }}>
          <TrashSimple size={24} />
        </Button>
      </div>
      <div className="ml-[15%] grow">
        <Button
          className="text-primary hover:bg-surface-hovered focus-visible:bg-surface-focused active:bg-surface-pressed flex bg-transparent"
          onClick={(e) => {
            e.stopPropagation()
            onShowNews(dataNews.id)
          }}>
          <BellRinging size={24} />
          {t("admin.news.showNow")}
        </Button>
      </div>
    </div>
  )
}

export { PlannedNews }
